import { useRef, useEffect } from "react";
const useYResize = ({
  el,
  onResize
}) => {
  const resizeCbRef = useRef(onResize);
  useEffect(() => {
    if (el) {
      const observer = new ResizeObserver(([entry]) => {
        var _a;
        (_a = resizeCbRef.current) == null || _a.call(resizeCbRef, entry.borderBoxSize[0].blockSize);
      });
      return observer.observe(el, { box: "border-box" }), () => {
        observer.disconnect();
      };
    }
  }, [el]);
};
export {
  useYResize
};
//# sourceMappingURL=useYResize.js.map
